import { Component, OnInit, Input } from '@angular/core';

import { Dimensions, Serie } from '../../../models';

@Component({
    selector: '[aaColumnGroup]',
    templateUrl: './column-group.component.html',
    styleUrls: [
        './column-group.component.scss'
    ],
    standalone: false
})
export class ColumnGroupComponent implements OnInit
{
    @Input() dimensions: Dimensions;
    @Input() serie: Serie;

    constructor ()
    { }

    ngOnInit ()
    {
    }
}
